import {omneticApi} from '@dms/api/base';

import {
  ClearBranchValueWithoutReferenceApiArg,
  ClearBranchValueWithoutReferenceApiResponse,
  ClearTenantValueWithoutReferenceApiArg,
  ClearTenantValueWithoutReferenceApiResponse,
  GetBranchSettingValuesApiArg,
  GetBranchSettingValuesApiResponse,
  GetEffectiveValueApiArg,
  GetEffectiveValueApiResponse,
  GetEffectiveValueWithoutReferenceApiArg,
  GetEffectiveValueWithoutReferenceApiResponse,
  GetTenantSettingValuesApiArg,
  GetTenantSettingValuesApiResponse,
  SetBranchSettingValueApiArg,
  SetBranchSettingValueApiResponse,
  SetTenantSettingValueApiArg,
  SetTenantSettingValueApiResponse,
} from './types';

export const generalSettingsApi = omneticApi.injectEndpoints({
  endpoints: (build) => ({
    getTenantSettingValues: build.query<
      GetTenantSettingValuesApiResponse,
      GetTenantSettingValuesApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/settings/${queryArg.settingId}/tenant`,
      }),
      providesTags: (result, error, queryArg) => [
        {type: 'GeneralSettingsTenant', id: queryArg.settingId},
      ],
    }),
    setTenantSettingValue: build.mutation<
      SetTenantSettingValueApiResponse,
      SetTenantSettingValueApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/settings/${queryArg.settingId}/tenant`,
        method: 'POST',
        body: queryArg.valueRequestBody,
      }),
      invalidatesTags: (result, error, queryArg) => [
        {type: 'GeneralSettingsTenant', id: queryArg.settingId},
      ],
    }),
    getBranchSettingValues: build.query<
      GetBranchSettingValuesApiResponse,
      GetBranchSettingValuesApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/settings/${queryArg.settingId}/branch`,
      }),
      providesTags: (result, error, queryArg) => [
        {type: 'GeneralSettingsBranch', id: queryArg.settingId},
      ],
    }),
    setBranchSettingValue: build.mutation<
      SetBranchSettingValueApiResponse,
      SetBranchSettingValueApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/settings/${queryArg.settingId}/branch/${queryArg.branchId}`,
        method: 'POST',
        body: queryArg.valueRequestBody,
      }),
      invalidatesTags: (result, error, queryArg) => [
        {type: 'GeneralSettingsBranch', id: queryArg.settingId},
      ],
    }),
    clearBranchValueWithoutReference: build.mutation<
      ClearBranchValueWithoutReferenceApiResponse,
      ClearBranchValueWithoutReferenceApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/settings/${queryArg.settingId}/branch/${queryArg.branchId}/without-reference`,
        method: 'DELETE',
      }),
      invalidatesTags: (result, error, queryArg) => [
        {type: 'GeneralSettingsBranch', id: queryArg.settingId},
      ],
    }),
    clearTenantValueWithoutReference: build.mutation<
      ClearTenantValueWithoutReferenceApiResponse,
      ClearTenantValueWithoutReferenceApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/settings/${queryArg.settingId}/tenant/without-reference`,
        method: 'DELETE',
      }),
      invalidatesTags: (result, error, queryArg) => [
        {type: 'GeneralSettingsTenant', id: queryArg.settingId},
      ],
    }),
    getEffectiveValue: build.query<GetEffectiveValueApiResponse, GetEffectiveValueApiArg>({
      query: (queryArg) => ({
        url: `/dms/v1/settings/${queryArg.settingId}/effective-value/myself/with-reference/resource/${queryArg.resourceId}/record/${queryArg.recordId}`,
      }),
    }),
    getEffectiveValueWithoutReference: build.query<
      GetEffectiveValueWithoutReferenceApiResponse,
      GetEffectiveValueWithoutReferenceApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/settings/${queryArg.settingId}/effective-value/myself/without-reference`,
      }),
      providesTags: (result, error, queryArg) => [
        {type: 'GeneralSettingsTenant', id: queryArg.settingId},
      ],
    }),
  }),
});

export const {
  useGetEffectiveValueQuery,
  useGetEffectiveValueWithoutReferenceQuery,
  useClearTenantValueWithoutReferenceMutation,
  useGetTenantSettingValuesQuery,
  useLazyGetBranchSettingValuesQuery,
  useSetTenantSettingValueMutation,
  useGetBranchSettingValuesQuery,
  useSetBranchSettingValueMutation,
  useClearBranchValueWithoutReferenceMutation,
} = generalSettingsApi;
